"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const react_1 = __importStar(require("react"));
const HeaderCell_1 = __importDefault(require("../HeaderCell"));
const Header_styles_1 = require("./Header.styles");
const HeaderLabel_1 = __importDefault(require("./HeaderLabel"));
const constants_1 = require("./constants");
const HeaderInner = ({ tableId, tableTop = 0, headerGroups, fixed = false, isLoading = false, filtersDisabled = false, sortingDisabled = false }, externalRef) => {
    const [top, setTop] = react_1.default.useState([]);
    /**
     * Callback ref for capturing a given header row's
     * offsetTop, needed for top of row for sticky header
     * see https://reactjs.org/docs/hooks-faq.html#how-can-i-measure-a-dom-node for more
     * Should we add resizing, we may want to move to a ResizeObserver approach
     */
    const rowRef = react_1.default.useCallback((node) => {
        if (node !== null) {
            setTop((prevTop) => {
                const newTop = [...prevTop];
                const index = parseInt(node.getAttribute('data-header-row-idx'));
                newTop[index] = node.offsetTop + tableTop;
                return newTop;
            });
        }
    }, [tableTop]);
    return (react_1.default.createElement("thead", { "data-testid": "header", ref: externalRef }, headerGroups.map((headerGroup, idx) => {
        const _a = headerGroup.getHeaderGroupProps(), { key: headerGroupKey } = _a, restHeaderGroupProps = __rest(_a, ["key"]);
        return (react_1.default.createElement(Header_styles_1.StyledHeaderRow, Object.assign({ "data-testid": "header-row", "data-header-row-idx": idx, key: headerGroupKey }, restHeaderGroupProps, { ref: rowRef }), headerGroup.headers.map((column) => {
            const _a = column.getHeaderProps(sortingDisabled ? {} : column.getSortByToggleProps()), { key: headerKey } = _a, restHeaderProps = __rest(_a, ["key"]);
            const { isSorted, isSortedDesc, minWidth, width, id } = column;
            const ariaSort = isSorted
                ? isSortedDesc
                    ? constants_1.SortOrder.DESC
                    : constants_1.SortOrder.ASC
                : constants_1.SortOrder.NONE;
            const headerLabel = column.render('Header');
            const getSortOrder = () => {
                const notSorted = sortingDisabled || !isSorted;
                const sortedDescOrAsc = isSortedDesc
                    ? constants_1.SortOrder.DESC
                    : constants_1.SortOrder.ASC;
                return notSorted ? constants_1.SortOrder.NONE : sortedDescOrAsc;
            };
            return (react_1.default.createElement(HeaderCell_1.default, Object.assign({ id: id, "data-testid": "header-cell", top: top[idx], key: headerKey, fixed: fixed, minWidth: minWidth, width: width, "aria-sort": ariaSort }, restHeaderProps),
                react_1.default.createElement(HeaderLabel_1.default, { headerLabel: headerLabel, sortOrder: getSortOrder() }),
                ((!filtersDisabled &&
                    !column.filterLocation &&
                    column.canFilter) ||
                    column.filterLocation === 'column') &&
                    column.canFilter &&
                    column.Filter
                    ? column.render('Filter', {
                        tableId,
                        showLabel: false,
                        isLoading
                    })
                    : null));
        })));
    })));
};
exports.Header = (0, react_1.forwardRef)(HeaderInner);
//# sourceMappingURL=Header.js.map